import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M92.9 22.4a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M81.16 15.34a1.5 1.5 0 0 1 0 2.121l-10 10a1.5 1.5 0 0 1-2.12-2.121l10-10a1.5 1.5 0 0 1 2.12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M69.04 15.34a1.5 1.5 0 0 1 2.12 0l10 10a1.5 1.5 0 0 1-2.12 2.121l-10-10a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path fill="#0597A3" d="M50.4 100.6a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M17.8 72a1.5 1.5 0 0 1 1.5 1.5v14.1a1.5 1.5 0 0 1-3 0V73.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M9.2 80.6a1.5 1.5 0 0 1 1.5-1.5h14.1a1.5 1.5 0 1 1 0 3H10.7a1.5 1.5 0 0 1-1.5-1.5M30.5 96.6a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M29.2 34.6c-2.9-1.4-6.3-.3-7.8 2.6l-9 17.3c-.7 1.4-.9 3-.4 4.5s1.6 2.7 3 3.4l8.8 4.4 13.7-28.1z"
    />
    <path
      fill="#00D8D8"
      d="M79.4 71.9c-2.4-1.7-11.6-8.4-11.6-8.4l-3 2.2c-5.2 3.9-12.4 3.9-17.6 0l-2-1.5c-2.6-1.9-3.1-5.6-1.2-8.2.2-.2.4-.5.6-.7L59 41s.2-.3.7-.5c.5-.3 11.7-1.1 11.7-1.1l-12.1-5.5c-1.3-.6-2.7-.7-4-.3l-17.8 5.2-13.8 28 19.8 15.5c.6.5 1.4.9 2.2 1.1L67 88.6c.5.1.9.2 1.4.2 1.6 0 3.1-.6 4.2-1.7l12-12c-.7-.4-3.1-1.7-5.2-3.2"
    />
    <path
      fill="#001A43"
      d="M103.2 59.3c.5-1.5.3-3.1-.4-4.5l-9-17.3c-1.5-2.8-5-4-7.8-2.5l-8.5 4.3L91.7 67l8.5-4.3c1.4-.6 2.5-1.9 3-3.4"
    />
    <path
      fill="#0597A3"
      d="M71.4 39.3s-11.2.9-11.7 1.1c-.5.3-.7.6-.7.6L44.7 55.3c-.2.2-.4.4-.6.7-1.9 2.6-1.4 6.2 1.2 8.2l2 1.5c5.2 3.9 12.4 3.9 17.6 0l3-2.2s9.2 6.7 11.6 8.4 5.3 3.3 5.3 3.3l6.9-8.1-14.3-27.8z"
    />
  </svg>
);
const SvgEnrichedIconPartnerInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconPartnerInverted);
export default Memo;
